// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyDuB7b0gtyp_EaQEP6OLiGDVt9U9q4YVtg",
  authDomain: "proveedores-mineros-2021.firebaseapp.com",
  projectId: "proveedores-mineros-2021",
  storageBucket: "proveedores-mineros-2021.appspot.com",
  messagingSenderId: "621314316623",
  appId: "1:621314316623:web:c67bf061685b3ad6748d3a",
  measurementId: "G-NLTWL0BQ0X"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/proveedores-mineros-2021.appspot.com/o/'